import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatHint, MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-description-edit',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormField,
    MatInputModule,
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    MatHint,
    FormsModule,
    MatSelectModule,
    MatOptionModule
  ],
  templateUrl: './description-edit.html',
  styleUrl: './description-edit.scss',
})
export class DescriptionEdit {
  @Input() dialogRef?: MatDialogRef<any>;
  readonly data = inject<string>(MAT_DIALOG_DATA);
  description: string = this.data;

  @Output()
  private _save = new EventEmitter<string>();

  public get save() {
    return this._save;
  }
  public set save(value) {
    this._save = value;
  }

  @Output() cancel = new EventEmitter<void>();
}
